<app-bottom-sheet-title
    [disabled]="isLoading"
    (dismiss)="dismiss()"
></app-bottom-sheet-title>
<div class="container">
    @for (categorizedResource of categorizedResources|keyvalue:originalOrder;
    track categorizedResource) {
    <div class="category">
        <div class="category__title">
            <span i18n>{{ categorizedResource.key }}</span>
        </div>
        <div class="category__resources">
            @for (resource of categorizedResource.value; track resource) {
            <app-toc-resource
                [resource]="resource"
                [isActive]="resource === currentResource"
                (clicked)="handleClick($event)"
                (changed)="flagForReload()"
            >
            </app-toc-resource>
            }
        </div>
    </div>
    }
</div>
